$(document).ready(function () {
  if ($(window).width() > 768) {
    $(".navbar-nav .dropdown").hover(function () {
      var isHovered = $(this).is(":hover");
      if (isHovered) {
        $(this).children("ul").stop().slideDown(300);
      } else {
        $(this).children("ul").stop().slideUp(300);
      }
    });
  }

  $('#brand-list-1').slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    responsive: [
      {
        breakpoint: 1680,
        settings: {
          variableWidth: false,
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          variableWidth: false,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
        }
      }
    ]
  });

  $('#brand-list-2').slick({
    speed: 8000,
    autoplay: true,
    autoplaySpeed: 0,
    centerMode: false,
    cssEase: 'linear',
    slidesToShow: 1,
    draggable: false,
    focusOnSelect: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    slidesToScroll: 1,
    variableWidth: true,
    infinite: true,
    initialSlide: 1,
    arrows: false,
    buttons: false,
    rtl: true,
    responsive: [
      {
        breakpoint: 1680,
        settings: {
          variableWidth: false,
          slidesToShow: 5,
        }
      },
      {
        breakpoint: 1024,
        settings: {
          variableWidth: false,
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 767,
        settings: {
          variableWidth: false,
          slidesToShow: 2,
        }
      }
    ]
  });

  /**************************************************************/
  /**************************************************************/

  function aboutTextReveal() {
    gsap.config({ trialWarn: false });
    console.clear();
    gsap.registerPlugin(ScrollTrigger, SplitText);
    /* let smoother = ScrollSmoother.create({
      smooth: 2
    }); */

    let splitText = $('.hm-about').find('p');
    let split = new SplitText(splitText, { type: "lines" });
    let masks;
    function makeItHappen() {
      masks = [];
      split.lines.forEach((target) => {
        let mask = document.createElement("span");
        mask.className = "mask";
        target.append(mask);
        masks.push(mask);
        gsap.to(mask, {
          scaleX: 0,
          transformOrigin: "right center",
          ease: "none",
          scrollTrigger: {
            trigger: target,
            markers: false,
            scrub: true,
            start: "top center",
            end: "bottom center"
          }
        });
      });
    }

    window.addEventListener("resize", newTriggers);

    function newTriggers() {
      ScrollTrigger.getAll().forEach((trigger, i) => {
        trigger.kill();
        masks[i].remove();
      });
      split.split();
      makeItHappen();
    }

    makeItHappen();
  }

  //aboutTextReveal();


  /*======================================================*/
  /*======================================================*/

  $(document).on('click', '.team-box', function () {
    setTimeout(() => {
      let profImg = $(this).find('img').attr('src');
      let profName = $(this).find('.profile-name').html();
      let profDesign = $(this).find('.profile-designation').html();
      let profDescription = $(this).find('.profile-description').html();
      let profLinkdin = $(this).find('.profile-Linkdin').html();
      $('.profile-detials .profile-img img').attr('src', profImg);
      $('.profile-detials .profile_name').html(profName)
      $('.profile-detials .profile_desgination').html(profDesign);
      $('.profile-detials .profDescription').html(profDescription);
      $('.profile-detials .profLinkdin').html(profLinkdin);
      $('.profile-detials').fadeIn();
    }, 0)
  })

  /*======================================================*/
  /*======================================================*/

  var memberBox = $('#our-team').find('.team-box');
  memberBox.each(function () {
    var THIS = $(this);
    THIS.mouseenter(function () {
      var currCaption = THIS.find('.caption');
      //currCaption.css({display:'none'}); 
      gsap.from(currCaption, { duration: 0.5, opacity: 0, y: 70, ease: "power2.out" });
    }).mouseleave(function () {
      $('.caption').css({ display: 'block' });
    });
  });


  $('.unmute').bind('click', function () {
    $("video").prop('muted', false);

    $('.unmute').css({ display: 'none' });
    $('.mute').css({ display: 'block' });
  });
  $('.mute').bind('click', function () {
    $("video").prop('muted', true);
    $('.unmute').css({ display: 'block' });
    $('.mute').css({ display: 'none' });
  });

  $(document).keydown(function (event) {
    // Check if the up or down arrow key was pressed (key codes 38 and 40)
    if (event.keyCode === 38 || event.keyCode === 40) {
      // Unmute the video
      if (isSectionOutOfView()) {
        $("video")[0].muted = true;
        $("video")[0].pause();
      }else{
         $("video")[0].muted = false;
         $("video")[0].play();
      }
    }
  });

  function isSectionOutOfView() {
    const section = $("#banner");
    const windowHeight = $(window).height();
    const windowScrollTop = $(window).scrollTop();
    const sectionOffset = section.offset().top;

    if (sectionOffset > windowScrollTop + windowHeight || sectionOffset + section.height() < windowScrollTop) {
      return true; // Section is out of view
    }
    return false; // Section is in view
  }




  let aboutTitle = new SplitType('[aboutText]', {
    types: 'lines, words, chars',
    tagName: 'b'
  })

  gsap.from('[aboutText] .word', {
    y: '100%',
    opacity: 0,
    duration: 1.5,
    ease: 'power1.out',
    stagger: 0.1,
    scrollTrigger: {
      trigger: '[aboutText]',
      start: 'top center',
    }
  })

  let abouttitle = new SplitType('[aboutTitle]', {
    types: 'lines, words, chars',
    tagName: 'b'
  })
  gsap.from('[aboutTitle] .line', {
    y: '100%',
    opacity: 0,
    duration: 1,
    ease: 'power1.out',
    stagger: 0.1,
    scrollTrigger: {
      trigger: '[aboutTitle]',
      start: 'top center',
    }
  })

  let client = new SplitType('[clientTitle]', {
    types: 'lines, words, chars',
    tagName: 'b'
  })
  gsap.from('[clientTitle] .word', {
    y: '100%',
    opacity: 0,
    duration: 1,
    ease: 'power1.out',
    stagger: 0.1,
    scrollTrigger: {
      trigger: '[clientTitle]',
      start: 'top center',
    }
  })

  let teamtext = new SplitType('[teamTitle]', {
    types: 'lines, words, chars',
    tagName: 'span'
  })
  gsap.from('[teamTitle] .line', {
    y: '100%',
    opacity: 0,
    duration: 1,
    ease: 'power1.out',
    stagger: 0.8,
    scrollTrigger: {
      trigger: '[teamTitle]',
      start: 'top center',
    }
  })


  gsap.from(".our-team-panel", {
    scrollTrigger: ".our-team-panel",
    y: 100,
    opacity: 0,
    duration: 1,
  });



  let Dreamers = new SplitType('[dreamersTitle]', {
    types: 'lines, words, chars',
    tagName: 'b'
  })
  gsap.from('[dreamersTitle] .word', {
    y: '100%',
    opacity: 0,
    duration: 1,
    ease: 'power1.out',
    stagger: 0.1,
    scrollTrigger: {
      trigger: '[dreamersTitle]',
      start: 'top center',
    }
  })


  gsap.from('.barand-slider', {
    y: '8%',
    opacity: 0,
    duration: 1,
    ease: 'power1.out',
    stagger: 0.5,
    scrollTrigger: {
      trigger: '.barand-slider',
      start: 'top center',
    }
  })



  let am = new SplitType('[amText]', {
    types: 'lines, words, chars',
    tagName: 'b'
  })

  gsap.from('[amText] .word', {
    y: '100%',
    opacity: 0,
    duration: 1.5,
    ease: 'power1.out',
    stagger: 0,
    scrollTrigger: {
      trigger: '[amText]',
      start: 'top center',
    }
  })




  gsap.from(".contact-us", {
    scrollTrigger: ".contact-us",
    y: 100,
    opacity: 0,
    duration: 1,
  });




});